import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from '@ups/security';
import { InternalAuthApiService } from './internal-auth-api.service';
import { Observable, switchMap, take } from 'rxjs';
import { ChangePasswordDto } from './model';

@Injectable({ providedIn: 'root' })
export class InternalAuthApiAuthenticatedService {
  authService = inject(AuthenticationService);
  internalAuthApi = inject(InternalAuthApiService);

  withToken<T>(callback: (accessToken: string) => Observable<T>) {
    return this.authService
      .getAccessTokenSilently()
      .pipe(take(1), switchMap(callback));
  }

  logout() {
    return this.withToken((accessToken) =>
      this.internalAuthApi.logout(accessToken)
    );
  }

  changePassword(data: ChangePasswordDto) {
    return this.withToken((accessToken) =>
      this.internalAuthApi.changePassword(data, accessToken)
    );
  }
}
